[
  {
    "id": "MET-B6P-L102-001",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Reken om: 2,5 meter = ... cm",
    "options": ["250 cm", "25 cm", "205 cm", "2.500 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-M-CM-KOMMA",
    "explanation": "1 meter is 100 cm. 2 meter is 200 cm. 0,5 meter is 50 cm. Samen 250 cm.",
    "distractorExplanations": {
      "1": "Dat is 0,25 meter.",
      "2": "Je hebt de 5 verkeerd geplaatst.",
      "3": "Dat is 25 meter."
    }
  },
  {
    "id": "MET-B6P-L102-002",
    "module": "Metriek",
    "difficulty": 102,
    "question": "De omtrek van een vierkant is 20 cm. Hoe lang is één zijde?",
    "options": ["5 cm", "4 cm", "10 cm", "2 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMTREK-VIERKANT",
    "explanation": "Een vierkant heeft 4 gelijke zijden. 20 : 4 = 5 cm.",
    "distractorExplanations": {
      "1": "Je hebt gedeeld door 5.",
      "2": "Je hebt gedeeld door 2.",
      "3": "Je hebt gedeeld door 10."
    }
  },
  {
    "id": "MET-B6P-L102-003",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Hoeveel gram is 0,5 kg?",
    "options": ["500 gram", "50 gram", "5 gram", "5.000 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-KG-G-HALF",
    "explanation": "1 kg = 1.000 gram. 0,5 kg is de helft, dus 500 gram.",
    "distractorExplanations": {
      "1": "Dat is 0,05 kg.",
      "2": "Dat is 0,005 kg.",
      "3": "Dat is 5 kg."
    }
  },
  {
    "id": "MET-B6P-L102-004",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Een rechthoek is 4 cm lang en 3 cm breed. Wat is de oppervlakte?",
    "options": ["12 cm²", "14 cm²", "7 cm²", "24 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-RECHTHOEK",
    "explanation": "Oppervlakte = lengte × breedte. 4 × 3 = 12 vierkante cm.",
    "distractorExplanations": {
      "1": "Dat is de omtrek (4+3+4+3).",
      "2": "Dat is lengte + breedte.",
      "3": "Je hebt de omtrek vermenigvuldigd."
    }
  },
  {
    "id": "MET-B6P-L102-005",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Hoeveel dl zit er in 1 liter?",
    "options": ["10 dl", "100 dl", "1.000 dl", "0,1 dl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-L-DL",
    "explanation": "Deci betekent tiende. Er gaan 10 deciliter in 1 liter.",
    "distractorExplanations": {
      "1": "Dat zijn centiliters.",
      "2": "Dat zijn milliliters.",
      "3": "Dat is 10 liter."
    }
  },
  {
    "id": "MET-B6P-L102-006",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Reken om: 1,5 km = ... meter",
    "options": ["1.500 m", "150 m", "15.000 m", "15 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-KM-M-KOMMA",
    "explanation": "1 km = 1.000 m. 1,5 km = 1.500 m.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-B6P-L102-007",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Een rechthoek is 6 cm lang en 2 cm breed. Wat is de omtrek?",
    "options": ["16 cm", "12 cm", "8 cm", "24 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMTREK-RECHTHOEK",
    "explanation": "Omtrek = alle zijden optellen. 6 + 2 + 6 + 2 = 16 cm.",
    "distractorExplanations": {
      "1": "Dat is de oppervlakte (6 × 2).",
      "2": "Je telde maar twee zijden op.",
      "3": "Je deed de oppervlakte keer 2."
    }
  },
  {
    "id": "MET-B6P-L102-008",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Hoeveel gram is 1,5 kg?",
    "options": ["1.500 gram", "150 gram", "15 gram", "15.000 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-KG-G-ANDERHALF",
    "explanation": "1 kg = 1.000 gram. 1,5 kg = 1.500 gram.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-B6P-L102-009",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Een vierkant heeft zijden van 5 cm. Wat is de oppervlakte?",
    "options": ["25 cm²", "20 cm²", "10 cm²", "50 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-VIERKANT",
    "explanation": "Oppervlakte van een vierkant = zijde × zijde. 5 × 5 = 25 cm².",
    "distractorExplanations": {
      "1": "Dat is de omtrek (4 × 5).",
      "2": "Dat is 2 × zijde.",
      "3": "Je deed 5 × 10."
    }
  },
  {
    "id": "MET-B6P-L102-010",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Hoeveel ml zit er in 0,5 liter?",
    "options": ["500 ml", "50 ml", "5.000 ml", "5 ml"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-HALVE-L-ML",
    "explanation": "1 liter = 1.000 ml. 0,5 liter = 500 ml.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-B6P-L102-011",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Reken om: 3,5 meter = ... cm",
    "options": ["350 cm", "35 cm", "3.500 cm", "305 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-M-CM-35",
    "explanation": "3 meter = 300 cm. 0,5 meter = 50 cm. Samen 350 cm.",
    "distractorExplanations": {
      "1": "Je deed ×10 in plaats van ×100.",
      "2": "Je deed ×1.000.",
      "3": "Je vergat de 50 cm."
    }
  },
  {
    "id": "MET-B6P-L102-012",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Hoeveel gram is 0,25 kg?",
    "options": ["250 gram", "25 gram", "2.500 gram", "2,5 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-KG-G-KWART",
    "explanation": "0,25 kg is een kwart kilogram. 1.000 : 4 = 250 gram.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-B6P-L102-013",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Een rechthoek is 8 cm lang en 5 cm breed. Wat is de oppervlakte?",
    "options": ["40 cm²", "26 cm²", "13 cm²", "80 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-RECHTHOEK-2",
    "explanation": "Oppervlakte = lengte × breedte. 8 × 5 = 40 cm².",
    "distractorExplanations": {
      "1": "Dat is de omtrek (8+5+8+5).",
      "2": "Dat is lengte + breedte.",
      "3": "Je deed de oppervlakte keer 2."
    }
  },
  {
    "id": "MET-B6P-L102-014",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Hoeveel dl zit er in 2 liter?",
    "options": ["20 dl", "200 dl", "2 dl", "0,2 dl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-2L-DL",
    "explanation": "1 liter = 10 dl. 2 liter = 20 dl.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×10.",
      "2": "Je deed ÷10 in plaats van ×10.",
      "3": "Je deed ÷100."
    }
  },
  {
    "id": "MET-B6P-L102-015",
    "module": "Metriek",
    "difficulty": 102,
    "question": "Een vierkant heeft een omtrek van 36 cm. Hoe lang is één zijde?",
    "options": ["9 cm", "6 cm", "12 cm", "18 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMTREK-VIERKANT-TERUG",
    "explanation": "Een vierkant heeft 4 gelijke zijden. 36 : 4 = 9 cm.",
    "distractorExplanations": {
      "1": "Je deelde door 6.",
      "2": "Je deelde door 3.",
      "3": "Je deelde door 2."
    }
  }
]